/**
 * @type {number} - Extra time to check if the access token is valid.
 */
export const /** @type {number} */ EXTRA_TIME_CHECK_VALID_ACCESS_TOKEN = 60;

/**
 * Event triggered to run the logout user logic.
 * @type {string} - The event name.
 */
export const TRIGGER_LOGOUT_USER_EVENT = 'trigger-logout-user';

/**
 * Event triggered to run the login user logic.
 * @type {string} - The event name.
 */
export const TRIGGER_LOGIN_USER_EVENT = 'trigger-login-user';
